import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("id");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => null);
  }, [orderId]);

  return (
    <div className="pt-40 pb-24 min-h-screen text-center" data-testid="order-success-page">
      <motion.div initial={{ scale: 0.85, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.5 }}>
        <CheckCircle2 size={56} strokeWidth={1.2} className="text-[#C9A961] mx-auto mb-6" />
      </motion.div>
      <div className="overline mb-3">Thank You</div>
      <h1 className="font-serif-display text-5xl md:text-7xl tracking-tighter font-light">
        Your ritual is on <em className="gold-text not-italic">its way</em>.
      </h1>
      {order && (
        <div className="max-w-md mx-auto mt-10 bg-[#F8F5F0] p-8 text-left" data-testid="order-summary-card">
          <div className="flex items-center justify-between border-b border-black/5 pb-3 mb-3">
            <span className="overline">Order</span>
            <span className="font-mono text-sm" data-testid="order-id">{order.order_id}</span>
          </div>
          <div className="flex items-center justify-between border-b border-black/5 pb-3 mb-3">
            <span className="overline">Status</span>
            <span className="text-sm uppercase tracking-widest text-[#C9A961]">
              {order.status === "paid" ? "Confirmed" : "Awaiting payment"}
            </span>
          </div>
          {order.is_slab_order && (
            <div className="flex items-center justify-between border-b border-black/5 pb-3 mb-3">
              <span className="overline">Slab applied</span>
              <span className="text-sm font-medium">{formatINR(order.slab_consumed_in_order || 0)}</span>
            </div>
          )}
          <div className="flex items-center justify-between">
            <span className="overline">{order.total > 0 ? "To pay" : "Total payable"}</span>
            <span className="font-serif-display text-2xl">
              {order.total > 0 ? formatINR(order.total) : <span className="text-[#16a34a]">₹0</span>}
            </span>
          </div>
        </div>
      )}
      <p className="text-sm text-[#5C5C5C] mt-8 max-w-md mx-auto">
        {order && order.total === 0
          ? "Your slab covers this order entirely — we'll pack and ship within 24 hours."
          : "We will verify your UPI payment and send a confirmation to your email within 30 minutes."}
      </p>
      <Link to="/shop" className="btn-outline mt-10 inline-flex" data-testid="order-success-continue">
        Continue Shopping
      </Link>
    </div>
  );
}
